import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import Checkbox from "material-ui/Checkbox";
import axios from "axios";
import toastr from "toastr";
import RaisedButton from "material-ui/FlatButton";
import Dialog from "material-ui/Dialog";
import Button from "react-bootstrap/lib/Button";
import moment from "moment";
import csvConvert from "../../../classes/csvConvert";

const offerType = {"Offer Made": "Offer Made", "Offer Rejected": "Offer Rejected", "Joined": "Joined"}


function dateFormat(cell) {
  if (cell != null && cell != 'NA' && cell != 0 && cell != 'null') {
    return <font>{new Date(cell).toDateString()}</font>
  }
  else
    return 'NA';
}

function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  switch (row.offerStatus) {
    case "Offer Made":
      return 'color5';
    case 'Offer Rejected':
      return 'color3';
    case  'Joined':
      return 'blue';
    default:
      return '';
  }
}
class NewJoinerTable extends React.Component {

  constructor() {
    super();
    this.state = {flag: {}, check: true, emailDialog: false, requestObjects: []};
    this.closeEmailDialog = this.closeEmailDialog.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this)
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={ {color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  downloadCsv() {
    let csvContent = new csvConvert();
    let dump = this.props.data;

    let tableData = csvContent.convertArrayOfJoinerObjectsToCSV({data: dump});
    console.log(tableData);
    let filename = moment(new Date()).format('YYYY-MM-DD');

    if (!tableData.match(/^data:text\/csv/i)) {
      tableData = 'data:text/csv;charset=utf-8,' + tableData;
    }
    tableData = encodeURI(tableData);
    let getCsv = new Promise((resolve, reject)=> {
      this.setState({csv: tableData});
      resolve(true);
    });
    getCsv.then((response)=> {
      this.download.click();
    })
  }

  closeEmailDialog() {
    this.setState({emailDialog: false})
  }

  componentDidMount() {
    let flag = new Object();
    console.log(this.props.data);
    this.props.data.map((node)=> {
      flag[node.id] = false;
    });
    this.setState({flag: flag})
  }

  componentWillReceiveProps(props) {

    let flag = new Object();
    console.log(props.data);
    props.data.map((node)=> {
      flag[node.id] = false;
    });
    this.setState({flag: flag})
  }

  render() {
    console.log(this.props.data);
    const actionDecline = [
      <RaisedButton
        label="Cancel"
        secondary={true}
        onTouchTap={this.closeEmailDialog}
      />,
      <RaisedButton

        label="Send Email for expected joiners"
        primary={true}
        disabled={false}
        onTouchTap={()=> {

          axios.post(process.env.REQ_URL + "/onBoarding/sendMailForExpectedJoiners", {data: this.state.requestObjects}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
            this.closeEmailDialog();
            this.props.refresh();
            toastr.success("Email Sent Successfuly")
          }).catch((error)=> {
            console.log(error);
          });
        }}
      />,];
    const options = {
      clearSearch: true,
      sizePerPageList: [10, 20, 30, 40, 200],
      paginationShowsTotal: this.renderShowsTotal// Enable showing total text
    };
    console.log(this.state.flag);
    return (
      <div >

        <Button
          onClick={this.downloadCsv}
          style={{backgroundColor: 'rgb(92, 184, 92)'}}
        ><i className="glyphicon glyphicon-download-alt">&nbsp;</i>Download</Button>

        <a href={this.state.csv} download={"OnBoarding" + moment(new Date()).format('YYYY-MM-DD')} ref={(input) => {
          this.download = input;
        }}/>
        <section >
          <BootstrapTable
            exportCSV={true}
            containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
            headerStyle={{
              borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
              , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
            }}
            search={true}
            striped
            options={options}
            pagination
            data={this.props.data}>
            <TableHeaderColumn
              hidden={true} isKey={true} dataField="id">Id</TableHeaderColumn>
            <TableHeaderColumn

              hidden={false} width={50} dataFormat={(cell, row)=> {

              return <Checkbox
                disabled={true}
                checked={row.offerStatus == 'Joined' ? true : false}
              />
            }} dataField="id">Id</TableHeaderColumn>
            <TableHeaderColumn
              filter={ {type: 'TextFilter', delay: 0, placeholder: 'Name'} }

              dataSort={true}
              dataFormat={(cell, row)=> {
                return <a onClick={()=> {
                  this.props.viewDetails(row.id);
                }}>{cell}</a>
              }}
              dataField="name">Name</TableHeaderColumn>
            <TableHeaderColumn
              filter={ {type: 'SelectFilter', options: this.props.constants.locationFilter, placeholder: 'Location'} }
              dataField="location">Location</TableHeaderColumn>
            <TableHeaderColumn
              filter={ {type: 'SelectFilter', options: this.props.constants.verticalFilter, placeholder: 'Vertical'} }

              dataField="vertical">Vertical</TableHeaderColumn>
            <TableHeaderColumn
              filter={ {type: 'TextFilter', delay: 0, placeholder: 'yyyy-mm-dd'} }
              dataFormat={dateFormat} dataField="oD">Offer Date</TableHeaderColumn>
            <TableHeaderColumn dataFormat={dateFormat}
                               filter={ {type: 'TextFilter', delay: 0, placeholder: 'yyyy-mm-dd'} }
                               dataField="jD">Date Of Joining</TableHeaderColumn>
            <TableHeaderColumn
              columnClassName={ columnClassNameFormat }
              filter={ {type: 'SelectFilter', options: offerType, placeholder: 'Offer Status'} }
              dataField="offerStatus">Offer Status</TableHeaderColumn>
            <TableHeaderColumn

              filter={ {type: 'TextFilter', delay: 0, placeholder: 'Recruiter'} }

              dataField="recruiter">Recruiter</TableHeaderColumn>

            <TableHeaderColumn dataFormat={(cell, row)=> {
              if (row.offerStatus != 'Joined')
                return <a onClick={(event)=> {
                  this.props.edit(row.id);
                }}> Click here to modify</a>
              else return 'Candidate has joined';
            }} dataField="function">Action</TableHeaderColumn>

          </BootstrapTable>
        </section>

        <Dialog
          title="Send Expected Joiners Email"
          actions={actionDecline}
          contentStyle={{height: "60%"}}
          autoScrollBodyContent={true}
          autoDetectWindowHeight={true}
          modal={false}
          open={this.state.emailDialog}
        >
          <div style={{"font-family": '"Roboto", "sans-serif"'}}>
            Send email to IT, Finance, Facilities, Vertical Head and the Manager.
            <br/>
            Expected Joiners:
            <ul>
              {this.state.requestObjects.map((node)=> {
                return <li>{node.name}</li>
              })}
            </ul>


          </div>
        </Dialog>

      </div>
    );
  }
}

NewJoinerTable.propTypes = {};

export default NewJoinerTable;





/** WEBPACK FOOTER **
 ** ./src/feature/onboarding/components/NewJoinerTable.js
 **/